<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  export default {
    name: 'ProductTitleBar',
    props: {
      options: Object,
      cart: Array,
    },
  }
</script>
